// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const keywords = "offre d emploi pharmacien, emploi pharmacien officine, assistant technique en pharmacie emplois, boticinal recrutement, cerp emploi pharmacien, Recrutement en pharmacie, Offres d'emploi officine, Postes pour pharmaciens, Emplois préparateurs en pharmacie, Stages en pharmacie, Jobs étudiants en officine, Géolocalisation offres pharmacie, Messagerie sécurisée pharmacie, Parrainage en pharmacie, Jeux concours pharmacie, Pharmaciens remplaçants, CDD pharmacie, CDI officine, Vendeurs en parapharmacie, Apprentis préparateurs pharmacie, Conditionneurs en pharmacie, Rayonnistes pharmacie, Optique lunetterie emploi, Audioprothésistes offres d'emploi, Service client pharmacie";
const SEO = () => {
  const { pathname } = useLocation();

  // Default SEO values
  let title = "Meet Pharma";
  let description = "MeetPharma est une plateforme de mise en relation entre pharmaciens et candidats en France. Grâce à des outils comme la géolocalisation, la messagerie sécurisée.";

  // Set meta tags based on route
  switch (pathname) {
    case "/":
      title = "Recrutement en Pharmacie | Trouvez un emploi ou un candidat près de chez vous.";
      description = "MeetPharma est une plateforme de mise en relation entre pharmaciens et candidats en France. Grâce à des outils comme la géolocalisation, la messagerie sécurisée.";
      break;
    case "/myOffers":
      title = "Offres de emploi - Meet Pharma";
      description = "Découvrez comment Meet Pharma connecte les pharmaciens et les candidats pour créer des opportunités uniques.";
      break;
    case "/chats":
      title = "Messagerie - Meet Pharma";
      description = "Profitez de la messagerie securisee de Meet Pharma pour communiquer facilement avec les pharmaciens et les candidats.";
      break;

    case "/profile":
      title = "Mon profil - Meet Pharma";
      description = "Gerez votre profil de pharmacien et profitez de toutes les fonctionnalités de Meet Pharma.";
      break;
    case "/login":
      title = "Connexion - Meet Pharma";
      description = "Connectez-vous et profitez de toutes les fonctionnalités de Meet Pharma.";
      break;
    case "/offersInRadius":
      title = "Offres dans votre rayon - Meet Pharma";
      description = "Trouvez des offres d'emploi dans votre rayon et profitez de la géolocalisation de Meet Pharma.";
      break;
    default:
      break;
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

export const SEOCustom = ({ title, description }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
}

export default SEO;
